import classnames from "classnames";
import React from "react";
import styles from "./styles.css";
import WarningIcon from "../icons/warning";
import { logEvent } from "../../util";

export class ConfirmationOverlay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      textModes: {
        "hair-to-makeup": {
          title: "You are changing the Hair mode to Makeup mode",
          description: `You wouldn't be able to see hairstyle apply in this mode.\nWould you like to continue?`,
        },
        "makeup-to-hair": {
          title: "You are changing the Makeup mode to Hair mode",
          description: `Makeup will be removed.\nWould you like to continue?`,
        },
        "t&c": {
          title: "Virtual Beauty",
          description0:
            "By using Virtual Beauty in the Ulta app, you acknowledge that you have read & agree to its terms and conditions (located at ",
          description1:
            "), including the collection, sharing, storage, & use of photos, videos, & facial geometry or landmarks. By tapping yes, you elect to share such information as set forth in the terms and conditions.",
        },
        error: {
          title: "Oops! something went wrong",
          description: "Please, try again.",
        },
        "session-expired": {
          title: "Your hair session has expired",
          description:
            "Your session ended, please take a photo again to continue the experience.",
        },
        leave: {
          title: "Leave site?",
          description:
            "We are still processing, are you sure you want to leave?",
        },
      },
    };

    this.sendLog = this.sendLog.bind(this);
    this.onConfirmClick = this.onConfirmClick.bind(this);
    this.onCancelClick = this.onCancelClick.bind(this);
  }

  sendLog(option) {
    if (
      this.props.mode === "hair-to-makeup" ||
      this.props.mode === "makeup-to-hair"
    ) {
      logEvent("try_on_switch", {
        from: this.props.mode === "hair-to-makeup" ? "Hair" : "Makeup",
        to: this.props.mode === "hair-to-makeup" ? "Makeup" : "Hair",
        option: option,
      });
    }

    if (this.props.mode === "t&c") {
      logEvent("legal_shown", {
        option: option,
      });
    }
  }

  onConfirmClick() {
    if (this.props.mode === "leave") {
      return;
    }

    this.sendLog("yes");
    let args = {};

    if (this.props.mode === "t&c") {
      args["tcAgreed"] = true;
    }
    this.props.onConfirmClick(args);
  }

  onCancelClick() {
    this.sendLog("no");

    if (this.props.mode === "t&c") {
      this.props.onConfirmClick({
        tcAgreed: false,
      });
    } else {
      this.props.onCancelClick();
    }
  }

  render() {
    return (
      <div className={classnames(styles.overlayWrapper)}>
        <div className={classnames(styles.overlayChangeMode, this.props.mode === 'tips' ? styles.isTip : '')}>
          <div className={classnames(styles.content)}>
            <WarningIcon className="mb-3" />

            {this.props.mode !== "tips" && (
              <h3>{this.state.textModes[this.props.mode].title}</h3>
            )}

            {this.props.mode !== "t&c" && this.props.mode !== "tips" && (
              <p>{this.state.textModes[this.props.mode].description}</p>
            )}

            {this.props.mode === "tips" && (
              <p className={classnames('text-left')}>
                <b>Tips:</b>
                <ul>
                  <li>Good lighting </li>
                  <li>Look straight</li>
                  <li>Hair back</li>
                  <li>No glasses</li>
                </ul>
              </p>
            )}

            {this.props.mode === "t&c" && this.props.mode !== "tips" && (
              <p>
                {this.state.textModes[this.props.mode].description0}
                <a
                  target="_blank"
                  href="https://www.ulta.com/company/terms-and-conditions"
                >
                  ulta.com/terms
                </a>
                {this.state.textModes[this.props.mode].description1}
              </p>
            )}

            {this.props.mode !== "error" &&
              this.props.mode !== "session-expired" &&
              this.props.mode !== "leave" &&
              this.props.mode !== "tips" && (
                <React.Fragment>
                  <button onClick={this.onConfirmClick}>Yes</button>
                  <button onClick={this.onCancelClick}>No</button>
                </React.Fragment>
              )}

            {this.props.mode === "leave" && (
              <React.Fragment>
                <button onClick={this.onConfirmClick}>Leave</button>
                <button
                  className={classnames(styles.roundButton)}
                  onClick={this.onCancelClick}
                >
                  Cancel
                </button>
              </React.Fragment>
            )}

            {this.props.mode === "error" && (
              <button onClick={this.props.onConfirmResetRestyle}>Okay</button>
            )}

            {(this.props.mode === "session-expired" ||
              this.props.mode === "tips") && 
                <button onClick={this.props.onConfirmResetRestyle}>
                  Got it!
                </button>
              }
          </div>
        </div>
      </div>
    );
  }
}
